import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgLinkedinLogoIcon = function SvgLinkedinLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    className: "zig-icon",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90,4H10c-3.3,0-6,2.7-6,6v80c0,3.3,2.7,6,6,6h80c3.3,0,6-2.7,6-6V10C96,6.7,93.3,4,90,4z M16.5,21.5c1.6-1.6,3.8-2.5,6-2.5  c0,0,0,0,0,0c2.2,0,4.4,0.9,6,2.5c1.6,1.6,2.5,3.7,2.5,6c0,2.3-0.9,4.5-2.6,6.1c-1.6,1.5-3.7,2.4-5.8,2.4c-0.1,0-0.1,0-0.2,0  c-2.1,0.1-4.3-0.8-5.9-2.4C14.9,32,14,29.8,14,27.5C14,25.2,14.9,23.1,16.5,21.5z M31,83.1c0,1.6-1.4,2.9-3,2.9H17c-1.6,0-3-1.4-3-3  V47c0-1.7,1.3-3,2.9-3H28c1.6,0,3,1.4,3,3V83.1z M86,84c0,1-1,2-2,2H71c-1,0-2-1-2-2V61.6c0-1.8-0.4-3.2-1.4-4.1  c-1.1-1.1-2.6-1.8-4.2-1.7c-3.3,0-7.5,2.8-7.5,5.9v22.6c0,1.1-1.1,1.8-2,1.8l-13,0c-0.9,0-2-0.7-2-1.8V45.9c0-1.1,1.1-1.9,2-1.9h12  c1,0,2,1,2,2v1.5c2.7-2.8,8.1-4.5,12-4.5h2.1C76.9,43,86,49.2,86,57.2V84z"
  })));
};

export { SvgLinkedinLogoIcon as ReactComponent };
